import { FormErrorMessage } from "@chakra-ui/react"
import { FormattedMessage } from "react-intl"

export const RequiredErrorMessage: React.FC = () => (
  <FormErrorMessage>
    <FormattedMessage id="required" />
  </FormErrorMessage>
)
